import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const ScopesActions = ({ parentUrl }) => (
  <div className="l-scopes__footer" style={{ gridArea: "footer" }}>
    <div className="l-flex-end-centered">
      <Link to={parentUrl} className="p-button u-no-margin--bottom">
        Close
      </Link>
    </div>
  </div>
);

ScopesActions.propTypes = {
  parentUrl: PropTypes.string.isRequired
};

export default ScopesActions;
